import { useState, useEffect } from "react";
import LoginForm from "../../molecule/LoginForm";
import SignUpForm from "../../molecule/SignUpForm";
import CountrySelection from "../../molecule/CountrySelection";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import * as Utilites from "@mywvglobal-shared/mywv-shared/common/utilities";
import { LoginWidgetContainerOther} from "../../atoms/Widget";
import { browserName } from "react-device-detect";
import { Tab, Tabs } from "react-bootstrap";
import LoaderPlaceholder from "../LoaderPlaceholder";

const LoginWidget = (props) => {
  const [key, setKey] = useState("login");
  const [soDetails, setSoDetails] = useState(undefined);
  const [signUpData, setSignUpData] = useState(undefined);
  const [isLogin, setIsLogin] = useState(true);
  const { loginReducer } = useSelector((state) => state);
  const { t } = useTranslation();
  const { persistItemsReducer } = useSelector((state) => state);
  const [executeSignIn, setExecuteSignIn] = useState(false);
  // const handleToggle = (e) => {
  //   e.preventDefault();
  //   setIsLogin(!isLogin);
  // }

  useEffect(() => {
    if(browserName == "Safari"){
      window.addEventListener( "pageshow", function ( event ) {
        var historyTraversal = event.persisted || 
                               ( typeof window.performance != "undefined" && 
                                    window.performance.navigation.type === 2 );
        if ( historyTraversal ) {
          // Handle page restore.
          window.location.reload();
        }
      });
    }
    
      
  })

  useEffect(() => {
    props?.setSoDetails(soDetails);
  }, [soDetails]);

  useEffect(() => {
    if (
      loginReducer?.getSOConfiguration?.signUpFormSettings
        ?.isInAppRegistrationEnabled
    ) {
      setSignUpData({
        signUpFormSettings: loginReducer?.getSOConfiguration?.signUpFormSettings,
        baseURL: loginReducer?.getSOConfiguration?.soBaseUrl,
        soCode: soDetails?.soCode,
        languageCode: soDetails?.soLanguageCode,
        phoneNumber: loginReducer?.getSOConfiguration?.phoneNumber,
      })
    } else if (isLogin === false) {
      setIsLogin(!isLogin);
    }
  }, [loginReducer]);

  // SignUp Click
  const onSignUpClick = () => {
    if (
      loginReducer?.getSOConfiguration?.signUpFormSettings
        ?.isInAppRegistrationEnabled
    ) {
      setSignUpData({
        signUpFormSettings: loginReducer?.getSOConfiguration?.signUpFormSettings,
        baseURL: loginReducer?.getSOConfiguration?.soBaseUrl,
        soCode: soDetails?.soCode,
        languageCode: soDetails?.soLanguageCode,
        phoneNumber: loginReducer?.getSOConfiguration?.phoneNumber,
      })
      setIsLogin(!isLogin);
    } else {
      const url = loginReducer?.getSOConfiguration?.registerationURL;
      window.open(url, "_self")
    }
  };

  useEffect(()=>{
    if(key==="register"){onSignUpClick()}
  },[key])


  return(
    <LoginWidgetContainerOther>

      <CountrySelection setSoDetails={setSoDetails}/>
         
          {Utilites.GetSOBasedConfiguration(
            loginReducer?.getSOConfiguration,
            "Login",
            "Registration",
          ) ? (
            
            <>
             <Tabs
              defaultActiveKey="login"
              id="login-selector"
              className="mb-3"
              onSelect={(k) => setKey(k)}
              style={{display: "none"}}
            >
              <Tab eventKey="login" title={t("Login")}>
                 <LoginForm soDetails={soDetails} executeSignIn={executeSignIn} setSoDetails={setSoDetails}/>
              </Tab>
              {persistItemsReducer?.selectedSOData?.soCode != "NZLO" &&
              <Tab eventKey="register" title={t("DT_WVM_ACC_HEAD_00100_SignUp")}>
                 <SignUpForm setExecuteSignIn={setExecuteSignIn} signUpData={signUpData} />
              </Tab>}
            </Tabs>
            </>
            )
          :
          <LoaderPlaceholder />
          }
               
      </LoginWidgetContainerOther>
      

  )
}

export default LoginWidget;